// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { IProjectHierarchyItem } from '../Interfaces/IProjectHierarchyItem';
import { SQWebArea } from '../Classes/SQWebArea';
import { Category } from '../Classes/Category';
import { SQWebMaterialCategory } from '../Classes/SQWebMaterialCategory';
import { SQWebLaborCategory } from '../Classes/SQWebLaborCategory';
export class SQWebProject implements IProjectHierarchyItem {
  areas: SQWebArea[];
  declare itemUniqueId: string;
  declare parentUniqueId: string;
  declare itemName: string;
  declare isItemVisible: boolean;
  declare referenceNumber: string;
  declare description: string;
  cost: number;
  declare notes: string;
  editBaseTaskGrid: boolean;
  editBaseTaskButtonText: string;
  revertGridChanges: boolean;
  isExpanded: boolean;
  isInEditMode: boolean;
  isEnabled: boolean;
  declare subcontractorCategory: Category;
  declare miscellaneousCategory: Category;
  declare riskCategory: Category;
  declare travelExpensesCategory: Category;
  declare shippingCategory: Category;
  declare warrantyCategory: Category;
  declare taxCategory: Category;
  declare laborTotalCategory: Category;
  subcontractorFeeCategory: Category;
  autoRiskCategory: Category;
  mechanicalFeeCategory: Category;
  technologyFeeCategory: Category;
  productivityReserveCategory: Category;
  declare totalMaterialCategory: SQWebMaterialCategory;
  declare siemensMaterialCategory: SQWebMaterialCategory;
  declare outsideMaterialCategory: SQWebMaterialCategory;
  declare mechanicalMaterialCategory: SQWebMaterialCategory;
  declare electricalMaterialCategory: SQWebMaterialCategory;
  declare projectManagerCategory: SQWebLaborCategory;
  declare engineerCategory: SQWebLaborCategory;
  declare networkEngineerCategory: SQWebLaborCategory;
  declare qualificationEngineerCategory: SQWebLaborCategory;
  declare cyberSecEngineerCategory: SQWebLaborCategory;
  declare energyEngineerCategory: SQWebLaborCategory;
  declare lengEngineerCategory: SQWebLaborCategory;
  declare graphicsCategory: SQWebLaborCategory;
  declare programmingCategory: SQWebLaborCategory;
  declare specialistCategory: SQWebLaborCategory;
  declare ddsCategory: SQWebLaborCategory;
  declare mechanicalCategory: SQWebLaborCategory;
  declare electricalCategory: SQWebLaborCategory;
  declare totalCost: number;
  laborTabNotes: string;
  additionalLaborRate: number;
  additionalLaborHours: number;
  additionalLaborCost: number;
  projectManagementDistributionHours: number;
  projectManagementDistributionSpread: number;
  engineeringDistributionHours: number;
  engineeringDistributionSpread: number;
  ppmCost: number;
  cpCost: number;
  securityMaterialCount: number;
  toolTip: string;
  nodeType: string;
  hasChildren: boolean;
}
